/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Market_Data_TitleInputs */

const en_landing_capability_market_data_title = /** @type {(inputs: Landing_Capability_Market_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backed by live market data`)
};

/**
* | output |
* | --- |
* | "Backed by live market data" |
*
* @param {Landing_Capability_Market_Data_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_market_data_title = /** @type {((inputs?: Landing_Capability_Market_Data_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Market_Data_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_market_data_title(inputs)
});